// extracted by mini-css-extract-plugin
module.exports = {"openModalBtn":"ChangeClinic_openModalBtn__27e2Z","footer":"ChangeClinic_footer__2rZ_-"};